import BaseModel from '../core/BaseModel'
export default class WarrantyReasonModel extends BaseModel {
    constructor() {
        super({ 
                name: "setting_reason_reject",
                tableName: 'core_setting_reason_reject'
            }, 
            {
            code: { 
                name: 'code', 
                type: "String", 
                label: 'Mã lý do',
                primaryKey: true,
                filter: { type: 'input', match: 'contains'},
                width: 10,
                sortable: true
            },
            reason_name: { 
                name: 'reason_name', 
                type: "String", 
                label: 'Lý do',
                filter: { type: 'input',match: 'custom'},
                sortable: true,
                width: 16,
            },
            is_add_note: {
                name: 'is_add_note', label: 'Nhập thêm nội dung', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 10, disabled: true,
                options: [{ value: true, label: 'Có'}, { value: false, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            reason_type: {
                name: 'reason_type', label: 'Loại lý do', type: "Selection", class: 'left disabled-select', dataType: 'Label', width: 12, disabled: true,
                options: [{ value: 'warranty_discontinuation', label: 'Đổi sản phẩm'},{ value: 'return_product', label: 'Trả sản phẩm'}, { value: 'not_accepted', label: 'Không nghiệm thu'}],
                filter: { type: 'select',  display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: true
            },
            is_change_product: {
                name: 'is_change_product', label: 'Đổi sản phẩm', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 10, disabled: true,
                options: [{ value: true, label: 'Có'}, { value: false, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status: {
                name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 10, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            ordering: { 
                name: 'ordering', 
                type: "String", 
                label: 'Thứ tự hiển thị',
                class: 'center',
                sortable: true,
                width: 8
            }
        },)
    }

}